import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  '大和ハウスグループの顧客接点を一元化する「HeartOneポータルアプリ」をプロダクトマネジメントから UX/UIデザイン・クラウドネイティブ開発まで一気通貫で支援。クレジットカード情報を扱う金融アプリのセキュリティ設計と、グループ各社との将来的な連携を見据えたアーキテクチャを実現した開発事例です。'

const ogpImg = 'https://aitria.co.jp/images/img/cases/heart-one/ogp_heartone.png'

export const heartOnePageMeta: PageMeta = {
  title: '大和ハウスフィナンシャル 金融ポータルアプリ開発｜PM〜設計・開発一気通貫の事例 | Aitria（アイトリア）',
  description,
  keyword: '事例 顧客接点 スマホアプリ プロダクトマネジメント UX/UI',
  image: ogpImg,
  url: `${SITE_URL}/cases/heart-one/`,
}

export const heartOneSchema = buildCaseStudySchema({
  slug: 'heart-one',
  pageTitle: heartOnePageMeta.title,
  description: heartOnePageMeta.description,
  headline: '新アプリ開発で顧客接点を一元化、グループ会社との連携も強化',
  alternativeHeadline: '大和ハウスフィナンシャル株式会社',
  primaryImage: ogpImg,
  images: [
    ogpImg,
    'https://aitria.co.jp/images/img/cases/heart-one/mv.webp',
  ],
  clientName: '大和ハウスフィナンシャル株式会社',
  breadcrumbLabel: '新アプリ開発で顧客接点を一元化、グループ会社との連携も強化',
})
